(function($) {

/* Navigation Toggle
   ========================================================================== */

$(document).on('click', '.navigation-toggle', function(e) {
	e.preventDefault();
	$(this).toggleClass('navigation-toggle-active');
	$('.navigation-collapse').toggleClass('navigation-open');
});

$(document).ready(function ($) {

	/* HTML5 Placeholder
	   ========================================================================== */

	$('input, textarea').placeholder();

	/* Tabset
	   ========================================================================== */

	var allTabLinks    = $('[data-tab]'),
		allTabContents = $('[data-content]');

	$('[data-tabset]').each(function () {
		var wrapper = $(this),
			group   = wrapper.data('tab-group'),
			scope = '[data-tab-group=' + group + ']',
			tabs    = allTabLinks.filter(scope),
			content = allTabContents.filter(scope);
		
		tabs.filter("[data-tab='1']").addClass('tab-link-active');
		content.filter("[data-content='1']").addClass('tab-active');
		
		tabs.on('click', function (event) {
			var tab = $(this),
				activeTab = tab.data('tab');
			
			if (window.innerWidth < 1024) {
				tabs
					.filter("[data-tab="+ activeTab +"]").toggleClass('tab-link-active');
				
				content
					.filter('[data-content=' + activeTab + ']').toggle();
			}
			else {
				tabs
					.removeClass('tab-link-active')
					.filter("[data-tab="+ activeTab +"]").addClass('tab-link-active');
				
				content
					.hide()
					.filter('[data-content=' + activeTab + ']').show();
			}
			
			$(window).on("load resize", function () {
				if (window.innerWidth > 1023) {
					tabs
						.removeClass('tab-link-active')
						.filter("[data-tab="+ activeTab +"]").addClass('tab-link-active');
				
					content
						.hide()
						.filter('[data-content=' + activeTab + ']').show();
				}
			}).resize();
			
			$.fn.matchHeight._update();
			event.preventDefault();
		});

		/**
		 * Warning: if you have duplicate tabs for both horizontal and vertical tabs
		 * simultaneously, this will wrap navigation around from start to finish because:
		 *
		 *   - Tab 1
		 *   - Tab 2
		 *   - Tab 3
		 *   - Tab 1
		 *
		 * Click next, and Tab 3 will wrap to Tab 1 because the second set of tabs'
		 * Tab 1 is next.
		 */

		wrapper.on('click', '[data-tab-prev]' + scope, function (event) {
			for (var i = tabs.length - 1; i >= 0; i--) {
				var tab = tabs.eq(i);

				if (tab.is('.tab-link-active')) {
					if (i > 0) {
						// Only go to the previous tab so long as we aren't on the first tab
						tabs.eq(i - 1).trigger('click');
					}

					break;
				}
			}

			event.preventDefault();
		});

		wrapper.on('click', '[data-tab-next]' + scope, function (event) {
			for (var i = 0, last = tabs.length - 1; i < last; i++) {
				var tab = tabs.eq(i);

				if (tab.is('.tab-link-active')) {
					if (i < last) {
						// Only go to the next tab so long as we aren't on the last tab
						tabs.eq(i + 1).trigger('click');
					}

					break;
				}
			}

			event.preventDefault();
		});
	});

	/* Accordion
	   ========================================================================== */

	var accordion = '[data-accordion]',
		accordionHeader = '[data-accordion-header]',
		accordionContent = '[data-accordion-content]',
		accordionActiveClass = 'accordion-active';

	$(accordion)
	.find(accordionContent).hide().end()
	.find(accordionHeader +':first').addClass(accordionActiveClass).end()
	.find(accordionContent +':first').show().end()
	.on('click', accordionHeader, function (event) {
		var self = $(this),
			accordionBody = self.closest(accordion);

		if (!self.hasClass(accordionActiveClass)) {
			accordionBody
				.find(accordionHeader).removeClass(accordionActiveClass).end()
				.find(accordionContent).slideUp().end();

			self.addClass(accordionActiveClass)
				.next(accordionContent).slideDown(function(){
					$.fn.matchHeight._update();
				}).end();

		}

		event.preventDefault();

	});

	/* Gallery Shortcode Fancybox
	   ========================================================================== */
	$(".gallery-thumbnail a").attr("rel","gallery");
	$(".gallery a").fancybox({
		maxWidth	: 800,
		maxHeight	: 600,
		fitToView	: false,
		width		: '70%',
		height		: '70%',
		autoSize	: false,
		closeClick	: false,
		openEffect	: 'none',
		closeEffect	: 'none'
	});

	/* Testimonials Fancybox
	   ========================================================================== */
	$(".various").fancybox({
        maxWidth    : 800,
        maxHeight   : 600,
        fitToView   : false,
        width       : '70%',
        height      : '70%',
        autoSize    : false,
        closeClick  : false,
        openEffect  : 'elastic',
        closeEffect : 'none',
        beforeLoad  : function(){
            var url= $(this.element).attr("href");
            url = url.replace(new RegExp("watch\\?v=", "i"), 'v/');
            url += '?fs=1&autoplay=1';
            this.href = url
        }
    });
		
}); // end.ready

}(jQuery));
